import { frag } from './dom';

/** Always-on disclosure. Spec §13.2: tokenization is local, no backend. */
export function renderDisclosure(root: HTMLElement): void {
  root.replaceChildren(frag(`
    <p class="ow-disclosure">tokenisering kjører lokalt i nettleseren med gpt-tokenizer (åpen kildekode)</p>
  `));
}

/** Rule-of-thumb sentence. Caller decides when to render — per spec §3, only after the user has typed something. */
export function renderRuleOfThumb(root: HTMLElement): void {
  root.replaceChildren(frag(`
    <p class="ow-rot">tommelfingerregel: ett token ≈ <strong>4.5 tegn engelsk</strong> · ≈ <strong>3.5 tegn norsk</strong> i moderne tokenisator</p>
  `));
}
